<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item active" aria-current="page">
				<fa-icon [icon]="ac.sectionIcons.zencustomers" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				ZEN Master Sites
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<button *ngIf="canAdd" type="button" class="btn btn-outline-primary me-2" routerLink="new">
				<fa-icon [icon]="['fas', 'plus']" size="sm"></fa-icon>
			</button>

			<button type="button" class="btn btn-outline-secondary me-2" routerLink="incidents">
				<fa-icon [icon]="['fas', 'dumpster-fire']" size="sm"></fa-icon>
				<span class="cp-action-button-text">Incidents</span>
			</button>

			<button type="button" class="btn btn-outline-secondary me-2" routerLink="reports">
				<fa-icon icon="table" size="sm"></fa-icon>
				<span class="cp-action-button-text">Reports</span>
			</button>

			<button type="button" class="btn btn-outline-secondary me-2" (click)="toggleFilters()">
				<fa-icon icon="filter" size="sm" ngbTooltip="Filter" placement="start"></fa-icon>
				<!-- <span class="cp-action-button-text">Filter</span> -->
			</button>

			<button type="button" class="btn btn-outline-secondary me-2" (click)="loadData(true)">
				<fa-icon icon="sync-alt" size="sm" [spin]="loading" ngbTooltip="Refresh" placement="start"></fa-icon>
				<!-- <span class="cp-action-button-text">Refresh</span> -->
			</button>

		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>
	<form [formGroup]="theForm" *ngIf="theForm && showFilters">
		<div class="row ps-2 pe-2">
			<div class="cp-filter-block-2">
				<ng-select [items]="enabledChoices" bindValue="value" bindLabel="label" id="enabledFilter" formControlName="enabledFilter"
					[multiple]="false" (change)="onFormChange()" placeholder="Enabled/Disabled">
				</ng-select>
			</div>

			<div class="cp-filter-block-2">
				<ng-select [items]="zmTypeChoices" bindValue="value" bindLabel="label" id="zmTypeFilters" formControlName="zmTypeFilters"
					[multiple]="true" [closeOnSelect]="false" (change)="onFormChange()" placeholder="Filter by Type">
				</ng-select>
			</div>

			<div class="cp-filter-block-2">
				<ng-select [items]="assessmentChoices" bindValue="value" bindLabel="value" id="assessmentFilters"
					formControlName="assessmentFilters" [multiple]="true" [closeOnSelect]="false" (change)="onFormChange()"
					placeholder="Filter by Assessment">
				</ng-select>
			</div>

			<div class="cp-filter-block-2">
				<ng-select [items]="recentTrafficChoices" bindValue="value" bindLabel="label" id="recentTrafficFilters"
					formControlName="recentTrafficFilters" [multiple]="true" (change)="onFormChange()"
					placeholder="Filter by Recent Traffic">
				</ng-select>
			</div>

			<div class="cp-filter-block-2">
				<ng-select [items]="activeBxChoices" bindValue="value" bindLabel="label" id="activeBxFilters"
					formControlName="activeBxFilters" [multiple]="true" (change)="onFormChange()" placeholder="Filter by Active Bx">
				</ng-select>
			</div>

			<div class="cp-filter-block-2">
				<ng-select [items]="accountOwnerChoices" bindValue="value" bindLabel="label" id="accountOwnerFilters"
					formControlName="accountOwnerFilters" [multiple]="true" (change)="onFormChange()" placeholder="Account Owner"
					[closeOnSelect]="false">
				</ng-select>
			</div>

			<div class="cp-filter-block-2">
				<ng-select [items]="seChoices" bindValue="value" bindLabel="label" id="seFilters" formControlName="seFilters"
					[multiple]="true" (change)="onFormChange()" placeholder="SE" [closeOnSelect]="false">
				</ng-select>
			</div>

			<div class="cp-filter-block-3">
				<ng-select [items]="specialChoices" bindValue="value" bindLabel="label" id="specialFilters" formControlName="specialFilters"
					[multiple]="true" (change)="onFormChange()" placeholder="Special">
				</ng-select>
			</div>

		</div>
	</form>

	<div *ngIf="loading" style="text-align: center;">
		<app-loading-spinner></app-loading-spinner>
	</div>

	<div *ngIf="recentZenCustomers && recentZenCustomers.length > 0" class="cp-light-message">
		Recently Viewed:
		<span *ngFor="let item of recentZenCustomers" class="me-1">
			<a [routerLink]="[item.id]">{{ item.name }}</a>;
		</span>
	</div>

	<div *ngIf="cachingUsageInfo && cachingUsageInfo !== ''" class="cp-light-message">
		<fa-icon icon="cog" size="sm" [spin]="true"></fa-icon>
		{{ cachingUsageInfo }}
	</div>

	<app-table-zens #zensTable1></app-table-zens>
</div>